var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list"},[_c('router-link',{staticClass:"link",attrs:{"to":"/setting/corp/info","tag":"a","active-class":"active"}},[_vm._v("\n      企业信息\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"to":"/setting/corp/invite-empl","tag":"a","active-class":"active"}},[_vm._v("\n      邀请员工\n    ")])],1),_vm._v(" "),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbb7b648","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/view/setting/corp/corpView.vue
// module id = null
// module chunks = 